/**
 * Base URL for the data collection backend (auth, registrations, etc.).
 * Use REACT_APP_API_URL in frontend/.env for local dev (e.g. http://localhost:5000)
 * so it wins over any REACT_APP_PUBLIC_API_URL set for other services (e.g. RAG).
 * Paths like /api/auth/register are appended; we use origin only to avoid double paths.
 */
function getDataCollectionApiBaseUrl() {
  const raw =
    process.env.REACT_APP_API_URL ||
    process.env.REACT_APP_PUBLIC_API_URL ||
    "http://localhost:5000";
  try {
    const url = new URL(raw);
    return url.origin;
  } catch {
    return raw.replace(/\/api\/v1\/?$|\/api\/?$/i, "") 
  }
}

export const dataCollectionApiBaseUrl = getDataCollectionApiBaseUrl();
